import { Box, Paper } from "@mui/material";
import { MouseEventHandler } from "react";
import { ISearchForm } from "../SearchHeader/SearchHeader";

export interface ActionPanelProps {
    /**
     * dialogBase children, usually the included sub-components.
     */
    children?: React.ReactNode;
    /**
     * The component used to render the search action content of the ActionPanel.
     * @default null
     */
    searchAction?: JSX.Element;
    /**
     * The component used to render the button action content of the ActionPanel.
     * @default null
     */
    buttonAction?: JSX.Element;

    /**
     * mouse click event handler for the new button.  this function determines the action that
     * are performed when the new button is clicked.
     */
    clickNew?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the view button.  this function determines the action that
     * are performed when the view button is clicked.
     */
    clickView?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Delete button.  this function determines the action that
     * are performed when the Delete button is clicked.
     */
    clickDelete?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Clear button.  this function determines the action that
     * are performed when the Clear button is clicked.
     */
    clickClear?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Search button.  this function determines the action that
     * are performed when the Search button is clicked.
     */
    clickSearch?: (data: ISearchForm) => Promise<void>;

    hideSearch?: boolean;

    hiddenSearchParams?: { name: string; value: string | number | undefined }[];
    additionalSearchParams?: string[];

    hideButtons?: boolean;
}

/**
 * The defaulf view for action component
 * @param searchAction
 * @param buttonAction
 */
export default function ActionPanel({ searchAction, buttonAction, children, hideSearch = false }: ActionPanelProps) {
    return (
        <Paper variant="outlined" style={{ width: "100%" }}>
            <Box
                className="actionPanelAlignment"
                style={{
                    display: "flex",
                    flex: "1",
                    padding: "8px",
                    overflowX: "auto"
                }}
            >
                <Box
                    className="actionPanelArrangement"
                    style={{
                        display: "flex",
                        flex: "1",
                        alignItems: "center",
                        justifyContent: "space-between",
                        //minWidth: '1100px'
                        width: "100%",
                        whiteSpace: "nowrap"
                    }}
                >
                    {!hideSearch && <Box> {searchAction ?? null}</Box>}
                    {children ? children : ""}
                    {buttonAction ? <Box> {buttonAction ?? null} </Box> : ""}
                </Box>
            </Box>
        </Paper>
    );
}
